module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (197).cd25673b.jpg";